import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Selector } from 'components/Selector/Selector';
import { moreFiltersLabel } from '../../filters/filters.messages';

export class FilterGroup extends Component {
  getFilterNames = () => {
    const { filterOptionContainers } = this.props;

    return filterOptionContainers.map(filterPanel => filterPanel.name);
  };

  handleOnClear = () => {
    const { onClear, onSetIsEditing } = this.props;

    const filterNames = this.getFilterNames();
    onClear(filterNames);
    onSetIsEditing(filterNames, false);
  };

  handleOnDone = () => {
    const { isOutOfSync, onSyncFilters, onSetIsEditing } = this.props;

    const filterNames = this.getFilterNames();
    if (isOutOfSync) {
      onSyncFilters(filterNames);
    }
    onSetIsEditing(filterNames, false);
  };

  handleToggleExpanded = () => {
    const { isEditing, onSetIsEditing } = this.props;
    const filterNames = this.getFilterNames();

    onSetIsEditing(filterNames, !isEditing);
  };

  render() {
    const { isMobile, isSelected, filterOptionContainers, isEditing } = this.props;

    return (
      <Selector isMobile={isMobile} isSelected={isSelected} isOpen={isEditing} onToggle={this.handleToggleExpanded}>
        {({ Controls, DisclosureArrow, Panel, Selection }) => (
          <div className="unified-filters__filter">
            <Selection>
              {moreFiltersLabel}
              <DisclosureArrow />
            </Selection>
            <Panel className="unified-filters__filter__panel--align-right" onClose={this.handleOnDone}>
              {filterOptionContainers.map(optionContainer => optionContainer.container)}
              <Controls disableClearControl={!isSelected} onClear={this.handleOnClear} onDone={this.handleOnDone} />
            </Panel>
          </div>
        )}
      </Selector>
    );
  }
}

FilterGroup.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  isOutOfSync: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClear: PropTypes.func.isRequired,
  onSyncFilters: PropTypes.func.isRequired,
  filterOptionContainers: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      container: PropTypes.node.isRequired,
    })
  ),
  isEditing: PropTypes.bool.isRequired,
  onSetIsEditing: PropTypes.func.isRequired,
};
